<script setup>
import { toRefs, computed } from "vue";

const props = defineProps({
  color: {
    type: String,
    default: 'primary'
  },
});

const { color } = toRefs(props);

const imageFile = computed(() => {
  return color?.value === "company" || color?.value === "employability"
    ? "logo_black.png"
    : "logo.png";
});
</script>

<template>
  <v-img
    :src="`/img/${imageFile}`"
    :style="
      color === 'company' || color === 'employability' ? 'opacity: 0.75' : ''
    "
  />
</template>
